import React, {useEffect, useState} from 'react';
import Close from "../../../resources/icon/close-white.png";
import useCodeData from "../../../hooks/useCodeData";

import JellyCheckBox from "../../search/JellyCheckBox";
import CommonPagination from "../../table/movable/CommonPagination";
import {DrawerTriger} from "../drawer/Style";
import {
    searchOnchangeHandler,
    subSearchObjectListener,
    subSearchRawValueListener
} from "../../commonmethod/simmsDrawerMethod";
import {ListArray} from "./ListArray";


/**
 * data         |  필수  |  obj  | 선택된 값
 * onChange     |  필수  |   f   | 선택된 값을 변경해주는 세터    |
 * entity       |  필수  |  obj  | 드로어에 나와야 하는 코드값  | {name, (옵셔널)parentKey }
 *
 * constraint   | 옵셔널 |  obj  | { required, lessThan, largerThan }
 * auth         | 옵셔널 | bool  | 수정가능 여부, 없으면 수정 불가.
 * placeHolder  | 옵셔널 |   v   | 버튼의 기본 문구. 없으면 '선택'
 * title        | 옵셔널 |   v   | 드로어의 탸이틀
 * uniqueKey    | 옵셔널 |   v   | useCodeData 의 검색조건, 페이징을 분리하기 위한 캐싱 키(중복되지 않도록)
 * recursive    | 옵셔널 | bool  | 목록이 재귀형 데이터 인지 
 * children     | 옵셔널 |  []   | 검색 컴포넌트
 *
 * 사용 시 주의사항
 * 1. <SimmsInputSearch type={'TEXT'} />와 같은 하위항목이 존재할 시 recursive 옵션이 있더라도 하위탐색 시 enter키로 제어됨
 * */


function SimmsDrawerArray({onChange, all, page, data, title, entity, parentKey, constraint, auth, recursive, placeHolder, children, uniqueKey, ...rest }) {
    useEffect(() => {

        const label = Array.isArray(data) && data.length
            ? `${data[0].name || data[0].assetName} ${data.length > 1 ? ` 외 ${data.length - 1}${data[0].name ? '명' : '개'}` : ''}`
            : placeHolder ?? '선택';

        setLabel(label);
        if(autoClose) {
            closeDrawer()
        }
    },[data?.length])

    const [autoClose, setAutoClose] = useState(false)
    const [label, setLabel] =useState();
    const [subSelected, setSubSelected] = useState({});
    const [slideIn, setSlideIn] =useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [totalSelect, setTotalSelect] = useState(false);
    const {dataSet, loading,pageInfo, handlePageChange, searchConditions, handleSearch } = useCodeData(entity, uniqueKey );

    let totalChecked = !dataSet?.content.some(item => !new Set(data?.map(d => d.id)).has(item.id)) ? totalSelect : false;

    const closeDrawer=()=>{
        document.body.style.overflow = "auto";
        setSlideIn(false)
    }

    const openDrawer =()=>{
        if(!auth) {
            alert("권한이 없습니다.")
            return;
        }

        document.body.style.overflow = "hidden";
        setSlideIn(true);
    }

    const handleCheckboxChange = (event) => {
        setAutoClose(event.target.checked);
    };

    const handlePageSelect = (event) => {

        if(event.target.checked){
            page(true, dataSet.content)
        }else{
            page(false, dataSet.content)
        }
    };

    const handleTotalSelect = (event) => {
        setTotalSelect(event.target.checked);
        if(event.target.checked){
            all(true, searchConditions)
        }else{
            all(false, null)
        }
    };

    let codes = [];
    if(!loading && dataSet) {
        if (parentKey) {
            codes = dataSet.filter(each => each.id === parentKey);
        } else {
            codes = [{children : dataSet.content ?? dataSet}];
        }
    }

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {

            if (child.props.type === 'HIDDEN') {
                // 'HIDDEN' type인 경우 searchConditions의 entityId 값에 hiddenValue의 value로 설정
                searchConditions.entityId = child.props.value;
            }

            const customOnChange = (value) => {if (typeof value === 'object' && value !== null) {
                    subSearchObjectListener(setSubSelected, handleSearch, value, searchConditions, { t: child.props.target, uniqueKey: child.props.uniqueKey });
                }else{
                    subSearchRawValueListener(setSubSelected,  handleSearch, value,searchConditions, { uniqueKey: child.props.uniqueKey });
                }
            };
            const isTextType = child.props.type === 'TEXT'; // 예시로 uniqueKey를 조건으로 사용
            const hiddenValue = child.props.type === 'HIDDEN';

            return React.cloneElement(child, {
                onChange: customOnChange,
                onKeyDown: customOnChange,
                data: subSelected[child.props.target],
                isTextType: isTextType,
            });
        }

        return child;
    });

    const gridChildren = [];
    const specialChildren = [];

    React.Children.forEach(childrenWithProps, child => {
        if (child.props.isTextType) {
            specialChildren.push(child);
        } else {
            gridChildren.push(child);
        }
    });

    const marginHeight = ((childrenWithProps?.length / 2) * 20 ) + (specialChildren.length * 25); ;


    useEffect(() => {
        if (handleSearch) {
            const searchParams = {
                ...subSelected,
            };
            handleSearch(searchParams);
        }
    }, [subSelected]);

    return (
        <div className={"block mr-2"}>
            {/*선택버튼*/}
            <DrawerTriger onClick={openDrawer} required={constraint?.required} value={label}>{label}</DrawerTriger>
            <div className={`drawer-background ${slideIn ? 'show' : 'none'}`} onClick={() => closeDrawer()}></div>


            {/*드로어*/}
            <div className={`drawer-view px-[2rem] py-[1rem] ${slideIn ? 'slide-in' : ''}`}
                 style={{width: '450px'}}>

                {/*드로어 헤더*/}
                <div className="flex drawer-title border-bb">
                    <span className={`text-[20px] font-bold`}>{title}</span>
                    <img src={Close} className="close-drawer2" onClick={closeDrawer}/>
                </div>

                {specialChildren &&
                    <div className="mb-[10px] indent-0">
                        {specialChildren}
                    </div>
                }

                {childrenWithProps ? (
                    <div className={`children-mb-3 'isDetailOpen grid  grid-cols-2`}>
                        {gridChildren}
                    </div>
                ) : (
                    <div className={'flex'}>
                        <input autoComplete="off" id="name" placeholder={`검색하세요.`}
                               onChange={(e) => searchOnchangeHandler(dataSet, e, expandedMenus, setExpandedMenus)}
                               className={"outline-1 flex w-[calc(100%-55px)] h-[30px] mb-[10px] border line-height-30 pl-[10px]"}/>
                    </div>
                )}



                <div className={'flex'}>
                    <JellyCheckBox
                        title={"자동닫힘"}
                        checked={autoClose}
                        fnc={handleCheckboxChange}
                    />
                </div>

                <p className={`my-[10px] text-[15px]`}>선택 * </p>
                    <div className="flex h-[30px] mb-[10px] border-b line-height-30 ">
                    {page &&    //전체선택, 페이지 선택 있을 때만 보임
                        <JellyCheckBox
                            className={`mr-3`}
                            title={'페이지 선택'}
                            checked={!dataSet?.content.some(item => !new Set(data?.map(d => d.id)).has(item.id))}
                            fnc={handlePageSelect}
                        />
                    }
                    {all &&
                        <JellyCheckBox
                            title={'전체선택'}
                            checked={totalChecked}
                            fnc={handleTotalSelect}
                        />
                    }
                    </div>
                <div className={`border overflow-y-auto h-drawer`}
                     style={{
                         height: `calc(100vh - ${pageInfo.totalPages > 0 ? 280 + marginHeight : 250 + marginHeight}px)`,
                     }}
                >
                    {!loading && dataSet &&
                        <ListArray list={codes[0].children}
                                   onChange={onChange}
                                   data={data}
                                   expandedMenus={expandedMenus}
                                   setExpandedMenus={setExpandedMenus}
                                   required={constraint?.required}
                                   recursive={recursive}/>}
                </div>
                {pageInfo && pageInfo.totalPages > 0 &&
                    <CommonPagination page={pageInfo} onPageChange={handlePageChange}/>
                }
            </div>

        </div>

    );
}

export default SimmsDrawerArray;
